import { takeLatest, call, put } from 'redux-saga/effects';
import { LOAD_GLOBAL_BANK_LIST } from 'state/actionTypes';
import * as api from 'api/global';
import * as toastActions from 'state/toast/actions';
import { setGlobalBankList } from 'state/global/actions';

export function* loadGlobalBankList() {
  try {
    yield put(setGlobalBankList([]));
    const { data: responseData } = yield call(api.getBanks);
    yield put(setGlobalBankList(responseData.data));
  } catch (e) {
    yield put(toastActions.errorMessage('Get Banks List Failed', e.message));
  }
}

export default function*() {
  yield takeLatest(LOAD_GLOBAL_BANK_LIST, loadGlobalBankList);
}
